var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _circle, _path9, _path10, _circle2, _path11, _path12, _path13, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 283,
    viewBox: "0 0 614 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.083 231.787V111.021C104.083 103.532 104.316 94.7553 104.784 84.6915C105.485 74.6276 105.952 65.8511 106.186 58.3617H104.784C101.046 64.9149 96.9571 71.5851 92.5181 78.3723C88.0791 84.9255 83.8737 91.5957 79.902 98.383L56.7725 136.298H185.737V181.936H0V139.809L85.8596 9.21277H160.154V231.787H104.083Z",
    fill: "#00A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.083 231.787V111.021C104.083 103.532 104.316 94.7553 104.784 84.6915C105.485 74.6276 105.952 65.8511 106.186 58.3617H104.784C101.046 64.9149 96.9571 71.5851 92.5181 78.3723C88.0791 84.9255 83.8737 91.5957 79.902 98.383L56.7725 136.298H185.737V181.936H0V139.809L85.8596 9.21277H160.154V231.787H104.083Z",
    fill: "url(#paint0_linear_4543_12833)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.083 231.787V111.021C104.083 103.532 104.316 94.7553 104.784 84.6915C105.485 74.6276 105.952 65.8511 106.186 58.3617H104.784C101.046 64.9149 96.9571 71.5851 92.5181 78.3723C88.0791 84.9255 83.8737 91.5957 79.902 98.383L56.7725 136.298H185.737V181.936H0V139.809L85.8596 9.21277H160.154V231.787H104.083Z",
    fill: "url(#paint1_linear_4543_12833)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M524.346 231.787V111.021C524.346 103.532 524.579 94.7553 525.047 84.6915C525.748 74.6276 526.215 65.8511 526.448 58.3617H525.047C521.309 64.9149 517.22 71.5851 512.781 78.3723C508.342 84.9255 504.137 91.5957 500.165 98.383L477.035 136.298H606V181.936H420.263V139.809L506.123 9.21277H580.417V231.787H524.346Z",
    fill: "#00A6A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M524.346 231.787V111.021C524.346 103.532 524.579 94.7553 525.047 84.6915C525.748 74.6276 526.215 65.8511 526.448 58.3617H525.047C521.309 64.9149 517.22 71.5851 512.781 78.3723C508.342 84.9255 504.137 91.5957 500.165 98.383L477.035 136.298H606V181.936H420.263V139.809L506.123 9.21277H580.417V231.787H524.346Z",
    fill: "url(#paint2_linear_4543_12833)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M524.346 231.787V111.021C524.346 103.532 524.579 94.7553 525.047 84.6915C525.748 74.6276 526.215 65.8511 526.448 58.3617H525.047C521.309 64.9149 517.22 71.5851 512.781 78.3723C508.342 84.9255 504.137 91.5957 500.165 98.383L477.035 136.298H606V181.936H420.263V139.809L506.123 9.21277H580.417V231.787H524.346Z",
    fill: "url(#paint3_linear_4543_12833)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.583 229.787V231.287H109.083H165.154H166.654V229.787V181.436H190.737H192.237V179.936V134.298V132.798H190.737H166.654V7.21277V5.71277H165.154H90.8596H90.0506L89.6062 6.38874L3.74662 136.984L3.5 137.36V137.809V179.936V181.436H5H107.583V229.787ZM64.4446 132.798L86.1825 97.1641L86.1897 97.1524L86.1966 97.1406C90.1516 90.382 94.3394 83.7397 98.76 77.2136L98.7668 77.2035L98.7735 77.1934C102.634 71.2906 106.232 65.4739 109.566 59.7434C109.309 66.4224 108.883 74.0365 108.287 82.5873L108.286 82.6046L108.285 82.6219C107.817 92.7016 107.583 101.502 107.583 109.021V132.798H64.4446ZM261.949 221.9L261.959 221.907C275.543 230.978 291.14 235.5 308.701 235.5C326.49 235.5 342.094 230.981 355.453 221.9C368.817 212.816 379.146 199.459 386.479 181.926C394.057 164.369 397.813 142.858 397.813 117.447C397.813 79.126 389.722 50.16 373.278 30.8193C356.858 11.2738 335.287 1.5 308.701 1.5C282.116 1.5 260.545 11.2733 244.125 30.8178C227.68 50.1585 219.589 79.125 219.589 117.447C219.589 142.857 223.228 164.365 230.569 181.919L230.572 181.927L230.576 181.935C238.143 199.465 248.588 212.818 261.949 221.9ZM324.99 56.1698L325.008 56.1832L325.027 56.1961C329.755 59.4257 333.708 65.7106 336.705 75.4109L336.71 75.4263L336.715 75.4417C339.91 85.0434 341.545 99.013 341.545 117.447C341.545 135.875 339.911 150.091 336.709 160.174L336.706 160.184L336.702 160.194C333.704 170.128 329.738 176.803 324.955 180.505C320.069 184.287 314.666 186.16 308.701 186.16C302.985 186.16 297.573 184.297 292.434 180.495C287.648 176.784 283.573 170.105 280.346 160.183C277.372 150.089 275.857 135.868 275.857 117.447C275.857 99.0186 277.374 85.0416 280.341 75.427C283.57 65.7282 287.636 59.4328 292.375 56.1961L292.387 56.1881C297.529 52.6043 302.957 50.8404 308.701 50.8404C314.689 50.8404 320.104 52.6104 324.99 56.1698ZM527.846 229.787V231.287H529.346H585.417H586.917V229.787V181.436H611H612.5V179.936V134.298V132.798H611H586.917V7.21277V5.71277H585.417H511.123H510.314L509.869 6.38874L424.01 136.984L423.763 137.36V137.809V179.936V181.436H425.263H527.846V229.787ZM527.846 109.021V132.798H484.708L506.446 97.1641L506.453 97.1524L506.46 97.1406C510.415 90.382 514.602 83.7397 519.023 77.2136L519.03 77.2035L519.036 77.1934C522.897 71.2906 526.495 65.4739 529.829 59.7434C529.572 66.4224 529.146 74.0365 528.55 82.5873L528.549 82.6046L528.548 82.6219C528.08 92.7016 527.846 101.502 527.846 109.021Z",
    stroke: "#12171C",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4543_12833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.5 234C291.233 234 275.95 229.553 262.65 220.66C249.583 211.766 239.317 198.66 231.85 181.34C224.617 164.021 221 142.723 221 117.447C221 79.2979 229.05 50.7447 245.15 31.7872C261.25 12.5957 282.367 3 308.5 3C334.633 3 355.75 12.5957 371.85 31.7872C387.95 50.7447 396 79.2979 396 117.447C396 142.723 392.267 164.021 384.8 181.34C377.567 198.66 367.417 211.766 354.35 220.66C341.283 229.553 326 234 308.5 234Z",
    fill: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5 234C291.233 234 275.95 229.553 262.65 220.66C249.583 211.766 239.317 198.66 231.85 181.34C224.617 164.021 221 142.723 221 117.447C221 79.2979 229.05 50.7447 245.15 31.7872C261.25 12.5957 282.367 3 308.5 3C334.633 3 355.75 12.5957 371.85 31.7872C387.95 50.7447 396 79.2979 396 117.447C396 142.723 392.267 164.021 384.8 181.34C377.567 198.66 367.417 211.766 354.35 220.66C341.283 229.553 326 234 308.5 234Z",
    fill: "url(#paint4_linear_4543_12833)",
    fillOpacity: 0.4
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.806 221.9L261.816 221.906C275.383 230.978 290.961 235.5 308.5 235.5C326.267 235.5 341.852 230.981 355.194 221.9C368.541 212.815 378.857 199.459 386.181 181.927C393.749 164.369 397.5 142.858 397.5 117.447C397.5 79.1257 389.42 50.1598 372.996 30.8191C356.597 11.2741 335.053 1.5 308.5 1.5C281.947 1.5 260.402 11.2743 244.004 30.8197C227.58 50.1604 219.5 79.1261 219.5 117.447C219.5 142.857 223.134 164.365 230.466 181.919L230.469 181.926L230.473 181.934C238.03 199.464 248.462 212.817 261.806 221.9Z",
    stroke: "#12171C",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 99,
    r: 20,
    fill: "#12171C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M338 103V103.5C338 106.814 340.686 109.5 344 109.5V109.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.488 111.255L349.703 111.338C351.131 111.886 352.733 111.173 353.281 109.745V109.745",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 99,
    r: 20,
    fill: "#12171C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M257 103V103.5C257 106.814 259.686 109.5 263 109.5V109.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.488 111.255L268.703 111.338C270.131 111.886 271.733 111.173 272.281 109.745V109.745",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340 164V164C327.259 164 315.447 170.666 308.861 181.574L308 183",
    stroke: "#12171C",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.5,
    cy: 274.5,
    rx: 46.5,
    ry: 8.5,
    fill: "#E2E2E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4543_12833",
    x: 218,
    y: 0,
    width: 181,
    height: 237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4543_12833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4543_12833",
    x1: 209,
    y1: 159,
    x2: 509,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860539,
    stopColor: "#F6673A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4543_12833",
    x1: 209,
    y1: 159,
    x2: 509,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860539,
    stopColor: "#F48E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4543_12833",
    x1: 209,
    y1: 159,
    x2: 509,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860539,
    stopColor: "#F6673A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4543_12833",
    x1: 209,
    y1: 159,
    x2: 509,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860539,
    stopColor: "#F48E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4543_12833",
    x1: 320.394,
    y1: 235.273,
    x2: 258.65,
    y2: 161.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6A6",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector404);
export default __webpack_public_path__ + "static/media/vector404.99e4842709eb60147b5195ed69a49a72.svg";
export { ForwardRef as ReactComponent };